module.exports = __webpack_public_path__ + "static/media/il.8cfa7ba1.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/il.svg
// module id = 673
// module chunks = 0